import { VApp } from 'vuetify/lib/components/VApp';
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VMain } from 'vuetify/lib/components/VMain';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VApp,[_c(VAppBar,{attrs:{"app":"","dense":"","color":"primary","dark":""}},[_c('span',[_vm._v("shirokuma_bot 表現ツール")]),_c(VSpacer),_c(VBtn,{attrs:{"text":"","to":"/melody"}},[_vm._v("演奏")]),_c(VBtn,{attrs:{"text":"","to":"/editor"}},[_vm._v("エディタ")])],1),_c(VMain,[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }